import React, { useEffect, createElement } from 'react';
export function DocumentHead() {
  useEffect(() => {
    // Set page title
    document.title = 'MeetOS — Infrastructure événementielle pour organisations';
    // Set lang attribute
    document.documentElement.lang = 'fr';
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'MeetOS est la plateforme événementielle — inscription, agenda, networking, check-in, exposants et analytiques dans une seule interface white-label.');
    // Set og:title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', 'MeetOS — Infrastructure événementielle');
  }, []);
  return null;
}